'use client';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Modal from '@/ui/modal';
import Button from '@/ui/button';
import Input from '@/ui/input';
import Checkbox from '@/ui/checkbox';
import useAuthStore from '@/store/auth';
import useModalStore from '@/store/modalStore';
import styles from './styles.module.css';
import {languageMap} from "@/utils/languageMap";

const LogIn = ({dict}) => {
    const {log_in, sign_up} = dict.button
    const {log_in_content} = dict.modal
    const {login, logout} = useAuthStore();
    const {
        isLoginModalOpen,
        closeLoginModal,
        openSignUpModal,
        openLoginModal,
        openForgotPassworModal,
        isForgotPassworModalOpen,
        closeForgotModal
    } = useModalStore();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [stayLoggedIn, setStayLoggedIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resetEmail, setResetEmail] = useState('');
    const [resetMessage, setResetMessage] = useState('');
    const isLoginDisabled = email.trim() === '' || password.trim() === '';

    useEffect(() => {
        if (isLoginDisabled) {
            setErrorMessage('');
        }
    }, [email, password]);

    const handleEmail = (event) => {
        setEmail(event.target.value);
    };

    const handlePassword = (event) => {
        setPassword(event.target.value);
    };

    const handleStayLoggedIn = () => {
        setStayLoggedIn(true);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !isLoginDisabled) {
            loginUser().catch((err) => {
                console.log(err)
            });
        }
    };

    const loginUser = async () => {
        const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');
        const credentials = {
            email,
            password
        };

        try {
            const response = await axios.post(`${apiUrl}/api/auth/sign_in/`, credentials, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.status === 200) {
                login(response.data, stayLoggedIn);
                closeLoginModal();
            } else {
                console.error('Login failed');
                logout();
                setErrorMessage('Password or email is incorrect');
            }
        } catch (error) {
            console.error('Error during login:', error);
            console.log('Error during login 2222:', error.response);
            setErrorMessage('Password or email is incorrect');
        }
    };

    const getLanguage = () => {
        if (typeof window !== 'undefined') {
            const lang = localStorage.getItem('language');
            return languageMap[lang] || 'ua';
        }
        return 'ua';
    };

    const handlePasswordReset = async () => {
        const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');
        try {
            const response = await axios.post(`${apiUrl}/api/auth/reset_password/`, {
                email: resetEmail,
                language: getLanguage()
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                setResetMessage('Password reset link has been sent to your email.');
            }
        } catch (error) {
            console.error('Error during password reset:', error);

            if (error.response && error.response.status === 422) {
                setResetMessage('Validation error: Please check your email address.');
            } else {
                setResetMessage('An error occurred. Please try again later.');
            }
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const loginInModal = () => {
        if (!isLoginDisabled) {
            loginUser().catch(error => console.error('Error fetching categories:', error));
        }
    };

    return (
        <div>
            <Button onClick={openLoginModal} title={log_in} type='login-in'/>
            <Modal
                isOpen={isLoginModalOpen}
                onClose={closeLoginModal}
                className={styles.login}
                type={'log-in'}
            >
                <div className={styles.login_content}>
                    <h1 className={styles.login__title}>{log_in_content.log_in}</h1>
                    <div className={styles.login__input_wrapper}>
                        <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder={log_in_content.e_mail}
                            value={email}
                            onChange={handleEmail}
                            onKeyPress={handleKeyPress}
                            required={true}
                        />
                        <Input
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder={log_in_content.password}
                            value={password}
                            onChange={handlePassword}
                            onKeyDown={handleKeyPress}
                            showPassword={showPassword}
                            onShowPassword={togglePasswordVisibility}
                            required={true}
                        />
                    </div>

                    {errorMessage && <p className={styles.error_message}>{errorMessage}</p>}

                    <div className={styles.login__button_wrapper}>
                        <Button onClick={loginInModal} title={log_in} type="login-modal" disabled={isLoginDisabled}/>
                        <Button onClick={openSignUpModal} title={sign_up} type="signup-modal"/>
                    </div>

                    <div className={styles.login__checkbox__wrapper}>
                        <div className={styles.login__checkbox_block}>
                            <Checkbox type={"grey"} checked={stayLoggedIn} onChange={handleStayLoggedIn}/>
                            <p className={styles.login__checkbox__description}>{log_in_content.stay_logged_in}</p>
                        </div>
                        <div onClick={openForgotPassworModal} className={styles.forgot__forgot_password}>{log_in_content.forgot}</div>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={isForgotPassworModalOpen}
                onClose={closeForgotModal}
                className={styles.forgot}
            >
                <div className={styles.forgot_content}>
                    <h1 className={styles.forgot__title}>{log_in_content.forgot}</h1>
                    <p className={styles.forgot__description}>{log_in_content.worry}</p>
                    <div className={styles.forgot__input_wrapper}>
                        <Input
                            id="resetEmail"
                            name="resetEmail"
                            type="email"
                            placeholder="Your e-mail"
                            value={resetEmail}
                            onChange={(e) => setResetEmail(e.target.value)}
                            required={true}
                        />
                    </div>
                    <div className={styles.forgot__button_wrapper}>
                        <Button onClick={handlePasswordReset} title={log_in_content.reset} type="login-modal"/>
                    </div>
                    {resetMessage && <p className={styles.reset_message}>{resetMessage}</p>}
                </div>
            </Modal>
        </div>
    );
};

export default LogIn;
